export default __webpack_public_path__ + "static/media/wi-fi.b35778b9.svg";